








































































import { Component, Vue } from 'vue-property-decorator';
import GoogleDrive from '@/lib/GoogleDrive';
import SettingsList from '@/components/SettingsList.vue';

@Component({
  components: { SettingsList },
})
export default class Settings extends Vue {

  private settings: any;
  private googleDrive: GoogleDrive;
  private profile: { name: string, email: string, avatar: string } | null = null;

  public constructor() {
    super();
    this.settings = this.$store.getters.settings;
    this.googleDrive = new GoogleDrive('SenTiLab');
  }

  private mounted() {
    this.googleDrive.on('profileUpdate', (profile: any) => {
      this.profile = profile;
    });
  }

  private beforeRouteLeave(to: any, from: any, next: any) {
    this.saveSettings();
    next();
  }

  private saveSettings() {
    this.$store.commit('saveSettings');
  }
}
